import React, { useEffect } from 'react';

import RequestExperience from 'app/modules/user/newReqExperience/NewReqExperience';
import { useHistory } from 'react-router-dom';
import useStore, { IStore } from 'app/store';

const RequestExp: React.FC = () => {
    const setSearchOrigin = useStore((state: IStore) => state.setSearchOrigin);
    const history = useHistory();
    useEffect(() => {
        setSearchOrigin(history?.location?.pathname);
    }, []);
    return (
        <div>
            <RequestExperience />
        </div>
    );
};

export default RequestExp;
